import Box, { type BoxProps } from '@mui/material/Box';
import ButtonBase, { type ButtonBaseProps } from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)<BoxProps>(({ theme }) => ({
  flex: '1 1 auto',
  padding: theme.spacing(1, 0.5),
  position: 'relative',

  '.kmx-car-tile[data-size="small"] &': {
    flex: '1 1 auto',
    overflow: 'hidden',
    padding: theme.spacing(0, 0, 0, 1.5),
  },

  '.kmx-car-tile[data-size="large"][data-featured="true"] &': {
    padding: theme.spacing(1),
  },

  '.kmx-car-tile[data-size="xlarge"] &': {
    flex: '0 0 auto',
    padding: theme.spacing(0, 3, 0, 4),
    width: '50%',
  },

  '.kmx-car-tile__pricing': {
    alignItems: 'center',
    marginTop: theme.spacing(0.5),

    '.kmx-car-tile[data-size="small"] &': {
      marginTop: 0,
    },

    '.kmx-car-tile[data-size="xlarge"] &': {
      marginTop: theme.spacing(1),
    },
  },

  '.kmx-car-tile__menu-button, .kmx-car-tile__compare-button': {
    float: 'right',
  },
}));

export const MonthlyPaymentButton = styled(ButtonBase)<ButtonBaseProps>(
  ({ theme }) => ({
    alignItems: 'center',
    display: 'inline-flex',
    gap: theme.spacing(0.25),
    whiteSpace: 'nowrap',

    '> .MuiTypography-root': {
      textDecoration: 'underline',
      textDecorationColor: theme.palette.divider,
    },
  }),
);

export const Actions = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1.5),

  '.kmx-car-tile[data-size="large"] &': {
    flexDirection: 'row-reverse',
  },

  '.kmx-car-tile[data-size="xlarge"] &': {
    marginTop: theme.spacing(3),
  },

  '.MuiButton-root': {
    flex: '1 0 max-content',
    whiteSpace: 'nowrap',

    // Give some more room for button content on the XL tile.
    '&.MuiButton-sizeLarge': {
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
  },
}));
